/**
 * Small admin-only strings merged into i18n after the main bundle.
 * Keeps the giant i18n.js object stable and avoids huge single-file edits.
 */
const es = {
  admin_dash_incident_tooltip: 'Este servicio tuvo una incidencia',
  admin_tariff_tier_basic_short: 'Básica',
  admin_dash_no_pending_invoice_this_period:
    'No hay servicios pendientes de facturar en este período',
};

const en = {
  admin_dash_incident_tooltip: 'This service had an incident',
  admin_tariff_tier_basic_short: 'Basic',
  admin_dash_no_pending_invoice_this_period:
    'No services pending invoicing in this period',
};

export function mergeAdminDashboardExtras(resources) {
  Object.assign(resources.es.translation, es);
  Object.assign(resources.en.translation, en);
}
